import { useRef } from 'react';

import { Dropdown } from 'src/common/components/Dropdow';
import { ModalRefProps } from 'src/common/components/Modal';
import { OrbitIcons } from 'src/common/constants.';

import { usePhoneListContext } from '../context';

import { PhoneAccountModal } from './PhoneAccountModal';
import { PhoneCampaignModal } from './PhoneCampaignModal';

export const PhoneActions = (): JSX.Element => {
  const { state } = usePhoneListContext();
  const { selectedPhones } = state;
  const phoneCampaignModal = useRef<ModalRefProps | null>(null);
  const phoneAccountModal = useRef<ModalRefProps | null>(null);

  const items = [
    {
      label: 'Assign campaign',
      icon: OrbitIcons.PhoneIncoming,
      onClick: (): void => {
        phoneCampaignModal?.current?.show();
      },
    },
    {
      label: 'Assign account',
      icon: OrbitIcons.UserPlus,
      onClick: (): void => {
        phoneAccountModal?.current?.show();
      },
    },
  ];

  return (
    <>
      <Dropdown items={items} label="Actions" disabled={!selectedPhones.length} />
      <PhoneCampaignModal ref={phoneCampaignModal} />
      <PhoneAccountModal ref={phoneAccountModal} />
    </>
  );
};
